import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Center from "./Center";
import Home from './Home';
import SearchResult from "./SearchResult";
import ScrollToTop from './ScrollToTop';

const Main = () => {

    return (
        <main id="main">
            <BrowserRouter>
                <ScrollToTop >
                    <Routes>
                        <Route path="/find-doctors" element={<Home />} />
                        <Route path="/find-doctors/centers/:name" element={<Center />} /> 
                        <Route path="/find-doctors/centers/:location/:radius/" element={<SearchResult />} />
                        <Route path="/find-doctors/centers/:location/:radius/:type/" element={<SearchResult />} />
                        <Route path="/find-doctors/centers/:location/:radius/:type/:name/" element={<SearchResult />} />
                    </Routes>
                </ScrollToTop>
            </BrowserRouter>
        </main>
    );
}

export default Main;